<template>
  <div class="main-menu">
    <router-link class="main-menu__logo" to="/accounts-list">CLEVELAND ADMIN PANEL</router-link>
    <div v-if="withNav" class="main-menu__nav-container">
      <router-link
        v-for="link in links"
        :key="link.name"
        :to="link.path"
        class="main-menu__item"
      >
        {{link.name}}
      </router-link>
    </div>
    <div v-if="withNav" @click="logout" class="main-menu__logout-button" >
      LOGOUT
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      withNav: {
        type: Boolean,
        default: true,
      }
    },
    data: ()=> ({
      links: [
        {name: 'Accounts', path: '/accounts-list'},
        {name: 'Intra-Transfers', path: '/intra-transfers'},
        {name: 'Payment Request', path: '/payment-request'},
        {name: 'Shops Payments', path: '/shops-payments'},
        {name: 'Create Client', path: '/add-client'},
        {name: 'Add Account', path: '/add-account'},
      ]
    }),
    methods:{
       logout() {
         this.$store.dispatch("logout");
         this.$router.push("/login");
      }
    },
  }
</script>

<style lang="scss" scoped>
  .main-menu {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 60px;
    background: #26a69a;
    margin-bottom: 25px;

    @media print {
      display: none;
    }

    &__logo {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }

    &__nav-container {
      display: flex;
    }

    &__item {
      margin-right: 20px;
      color: white;
    }

    &__logout-button {
      color: white;
      cursor: pointer;
      font-weight: 500;
    }
  }
</style>
